import {
  CompiledBacen,
  Detailed,
  DjangoCompiledBacen,
  DjangoDetailed,
  DjangoSummarized,
  DjangoTotalWages,
  Summarized,
  TotalWages,
} from './interfaces';

export function parseDjangoCompiledBacen(data?: DjangoCompiledBacen) {
  if (data) {
    const compiledBacen = {
      detailed: parseDjangoDetailed(data.detailed),
      summarized: parseDjangoSummarized(data.summarized),
      totalWages: parseDjangoTotalWages(data.total_wages),
    };
    return compiledBacen;
  } else {
    return undefined;
  }
}

export function parseCompiledBacen(data?: CompiledBacen) {
  if (data) {
    const compiledBacen = {
      detailed: parseDetailed(data.detailed),
      summarized: parseSummarized(data.summarized),
      totalWages: parseTotalWages(data.totalWages),
    };
    return compiledBacen;
  } else {
    return undefined;
  }
}

function parseDjangoDetailed(data?: Array<DjangoDetailed>) {
  if (data) {
    const arrayDetailed = data.map((detailed) => {
      const parsedDetailed = {
        type: detailed?.type,
        modality: detailed?.modality,
        domain: detailed?.domain,
        subdomain: detailed?.sub_domain,
        amount: detailed?.expiration_value,
      };
      return parsedDetailed;
    });
    return arrayDetailed;
  } else {
    return undefined;
  }
}

function parseDetailed(data?: Array<Detailed>) {
  if (data) {
    const arrayDetailed = data.map((detailed) => {
      const parsedDetailed = {
        type: detailed?.type,
        modality: detailed?.modality,
        domain: detailed?.domain,
        subdomain: detailed?.subDomain,
        amount: detailed?.expirationValue,
      };
      return parsedDetailed;
    });
    return arrayDetailed;
  } else {
    return undefined;
  }
}

function parseDjangoSummarized(data?: DjangoSummarized) {
  if (data) {
    const summarized = {
      damageOver12Months: data.damage_over_12_months,
      damageUpTo12Months: data.damage_up_to_12_months,
    };
    return summarized;
  } else {
    return undefined;
  }
}

function parseSummarized(data?: Summarized) {
  if (data) {
    const summarized = {
      damageOver12Months: data.damageOver12Months,
      damageUpTo12Months: data.damageUpTo12Months,
    };
    return summarized;
  } else {
    return undefined;
  }
}

function parseDjangoTotalWages(data?: Array<DjangoTotalWages>) {
  if (data) {
    const arrayTotalWages = data.map((totalWages) => {
      const parsedTotalWages = {
        type: totalWages?.modality,
        totalValue: totalWages?.amount,
      };
      return parsedTotalWages;
    });
    return arrayTotalWages;
  } else {
    return undefined;
  }
}

function parseTotalWages(data?: Array<TotalWages>) {
  if (data) {
    const arrayTotalWages = data.map((totalWages) => {
      const parsedTotalWages = {
        type: totalWages?.type,
        totalValue: totalWages?.totalValue,
      };
      return parsedTotalWages;
    });
    return arrayTotalWages;
  } else {
    return undefined;
  }
}
